import React from 'react'
import PropTypes from 'prop-types'
import { branch } from 'baobab-react/higher-order'

import { Image } from 'components/qstrap'
import intl from 'react-intl-universal'
import API from 'utils/API'
import storage from 'utils/storage'
import LayoutContext from 'utils/ui/LayoutContext'

import Filters from 'components/search/Filters'
import SearchNotFound from 'components/search/SearchNotFound'
import SchoolCardList from 'components/search/SchoolCardList'
import BaseTemplate from 'components/templates/BaseTemplate'
import AptitudeBanner from 'components/organisms/AptitudeBanner'

class Directory extends React.Component {
  constructor(props) {
    super(props)

    this.onFilterChange = this.onFilterChange.bind(this)
    this.onShowMore = this.onShowMore.bind(this)

    this.state = {
      page: 1,
      onLoading: false,
      bannerHeight: 0,
    }
  }

  onFilterChange(values) {
    const {
      locationId, studyFieldId,
    } = values

    this.setState({
      locationId,
      studyFieldId,
      page: 1,
      onLoading: true,
    }, () => {
      this.getSchools()
    })
  }

  onShowMore() {
    this.setState({
      page: this.state.page + 1,
      onLoading: true,
    }, () => {
      this.getSchools('showMore')
    })
  }

  getSchools(action = 'filter') {
    setTimeout(() => (
      API.get(`/search/schools${window.location.search}`, this.params()).then((response) => {
        const serverProps = storage.select('serverProps')
        let schoolData

        if (action === 'filter') {
          schoolData = response.data.schools
        } else {
          schoolData = [...this.props.schools, ...response.data.schools]
        }

        serverProps.merge({
          schools: schoolData,
          lastPage: response.data.lastPage,
          totalSchools: response.data.totalSchools,
          seed: response.data.seed,
        })

        this.setState({ onLoading: false })
      }).catch(() => {
        this.setState({ onLoading: false })
      })
    ), 500)
  }

  getHeight = (e) => {
    e.preventDefault()
    this.setState({ bannerHeight: e.target.offsetHeight })
  }

  params() {
    return {
      province_id: this.state.locationId,
      study_field_id: this.state.studyFieldId,
      page: this.state.page,
      seed: this.props.seed,
      study_field: this.props.params.study_field,
      location: this.props.params.location,
    }
  }

  render() {
    const loaderClass = this.state.onLoading ? '' : 'hide'

    let schoolsContainerClass
    let notFoundContainerClass

    if ((this.props.totalSchools === 0)) {
      schoolsContainerClass = 'hide'
      notFoundContainerClass = ''
    } else {
      schoolsContainerClass = ''
      notFoundContainerClass = 'hide'
    }

    return (
      <BaseTemplate useNewHeader>
        <div className="aptitude-banner-alt">
          <AptitudeBanner gaEventPath="ga/directory/aptitudetest" onLoad={this.getHeight} />
        </div>
        <LayoutContext.Consumer>
          {
            navbarState => (
              <Filters
                locations={this.props.locations}
                studyFields={this.props.studyFields}
                onChange={this.onFilterChange}
                selectedLocation={this.props.params.location || intl.get('search.filters.all_locations')}
                selectedStudyField={this.props.params.study_field || intl.get('search.filters.all_fields_of_study')}
                fixedNavbar={navbarState.fixedNavbar}
                navbarHeight={navbarState.navbarHeight}
                bannerHeight={this.state.bannerHeight}
              />
            )
          }
        </LayoutContext.Consumer>
        <div className={`${loaderClass} card-loader`}>
          <Image src="/assets/img/loader.gif" />
        </div>
        <div className={`not-found-container ${notFoundContainerClass}`}><SearchNotFound /></div>
        <div className={`card-list-container ${schoolsContainerClass}`}>
          <SchoolCardList
            schools={this.props.schools}
            onShowMore={this.onShowMore}
            totalSchools={this.props.totalSchools}
            lastPage={this.props.lastPage}
          />
        </div>
      </BaseTemplate>
    )
  }
}

Directory.propTypes = {
  locations: PropTypes.array,
  studyFields: PropTypes.array,
  schools: PropTypes.array,
  totalSchools: PropTypes.number,
  lastPage: PropTypes.bool,
  seed: PropTypes.number,
  params: PropTypes.object,
}

Directory.defaultProps = {
  locations: [],
  studyFields: [],
  schools: [],
  totalSchools: 0,
  lastPage: true,
  seed: 0,
  params: {},
}

export { Directory }
export default branch({
  locations: ['serverProps', 'locations'],
  studyFields: ['serverProps', 'studyFields'],
  schools: ['serverProps', 'schools'],
  totalSchools: ['serverProps', 'totalSchools'],
  lastPage: ['serverProps', 'lastPage'],
  seed: ['serverProps', 'seed'],
  params: ['serverProps', 'params'],
}, Directory)
